module.exports = __webpack_public_path__ + "static/media/blog2_2.e0619db2.webp";